import { SubVertical } from '../verticalService'

export enum CustomFilter {
  NONE = 'NONE',
  BRAND_ZZIM = 'BRAND_ZZIM',
  BRAND_CATEGORY = 'BRAND_CATEGORY',
  STORE = 'STORE',
  TITLE = 'TITLE',
  CERTIFICATION = 'CERTIFICATION',
}

type CustomFilterConfig = { [key in CustomFilter]?: { text?: string; searchField?: string } }

export const customFilterConfig: CustomFilterConfig = {
  NONE: {},
  BRAND_ZZIM: { text: '브랜드', searchField: 'brandIds' },
  BRAND_CATEGORY: { text: '카테고리' },
  STORE: { text: '스토어', searchField: 'storeIds' },
  TITLE: {},
  CERTIFICATION: { text: '인증상품', searchField: 'certifications' },
}

export enum Filter {
  ALL = 'ALL',
  DISPLAY = 'DISPLAY',
  NEW = 'NEW',
  CARRY_OVER = 'CARRY_OVER',
  NORMAL = 'NORMAL',
  COORDI = 'COORDI',
  DISCOUNT_70 = 'DISCOUNT_70',
  DISCOUNT_70_50 = 'DISCOUNT_70_50',
  DISCOUNT_50_20 = 'DISCOUNT_50_20',
  DISCOUNT_20 = 'DISCOUNT_20',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
  NEWS = 'NEWS',
  OUTLET_NOW = 'OUTLET_NOW',
  EVENT = 'EVENT',
}

export type FilterConfig = {
  [key in Filter]?: {
    text: string
    nClick: string
  }
}

export const filterConfig: FilterConfig = {
  ALL: {
    text: '전체상품',
    nClick: 'typeall',
  },
  DISPLAY: {
    text: 'display',
    nClick: 'typea',
  },
  NEW: {
    text: '신상',
    nClick: 'typeb',
  },
  CARRY_OVER: {
    text: '지난시즌',
    nClick: 'typec',
  },
  NORMAL: {
    text: '단품',
    nClick: 'typeitem',
  },
  COORDI: {
    text: '코디',
    nClick: 'typecoordi',
  },
  DISCOUNT_70: {
    text: '70%이상',
    nClick: 'typea',
  },
  DISCOUNT_70_50: {
    text: '70% - 50%',
    nClick: 'typeb',
  },
  DISCOUNT_50_20: {
    text: '50% - 20%',
    nClick: 'typec',
  },
  DISCOUNT_20: {
    text: '20%미만',
    nClick: 'typed',
  },
  SPECIAL_EVENT: {
    text: '기획전',
    nClick: 'filtere',
  },
  NEWS: {
    text: '소식',
    nClick: 'filtern',
  },
  OUTLET_NOW: {
    text: '아울렛소식',
    nClick: 'filtero',
  },
  EVENT: {
    text: '이벤트',
    nClick: 'filtere',
  },
}

export const getFilterBySubVertical = (subVertical: SubVertical): Filter[] => {
  switch (subVertical) {
    case SubVertical.DEPARTMENT:
      return [Filter.ALL, Filter.DISPLAY, Filter.NEW, Filter.CARRY_OVER]
    case SubVertical.OUTLET:
      return [Filter.ALL, Filter.DISCOUNT_70, Filter.DISCOUNT_70_50, Filter.DISCOUNT_50_20, Filter.DISCOUNT_20]
    case SubVertical.STYLE:
      return [Filter.ALL, Filter.NORMAL, Filter.COORDI]
    case SubVertical.ART:
      return [Filter.ALL, Filter.SPECIAL_EVENT, Filter.NEWS]
    case SubVertical.FOREIGN:
      return [Filter.ALL, Filter.EVENT, Filter.OUTLET_NOW]
    default:
      return []
  }
}

export const displayOnlyRelationProduct = filter => filter === Filter.DISPLAY || filter === Filter.COORDI
export const displayOnlyProduct = filter => [Filter.NEW, Filter.CARRY_OVER, Filter.NORMAL].includes(filter)

export const getTextOfALLBy = (subVertical: SubVertical) => {
  if (subVertical === SubVertical.DEPARTMENT) return '시즌 전체'
  if (subVertical === SubVertical.OUTLET) return '할인율 전체'
  if (subVertical === SubVertical.STYLE) return '단품/코디'
  if (subVertical === SubVertical.ART || subVertical === SubVertical.FOREIGN) return '전체'

  return filterConfig.ALL.text
}
